export class DbMongoBaseInfos {
  static readonly defaultId: number = -500;
  id: number = -500;
  isNew: boolean = true;

  constructor(init?: Partial<DbMongoBaseInfos>) {
    Object.assign(this, init);
  }
}
